module.exports = __webpack_public_path__ + "img/icons B_33.3bfb53e3.svg";